import { render, staticRenderFns } from "./SplitRule.vue?vue&type=template&id=5e1e05e2&scoped=true"
import script from "./SplitRule.vue?vue&type=script&lang=js"
export * from "./SplitRule.vue?vue&type=script&lang=js"
import style0 from "./SplitRule.vue?vue&type=style&index=0&id=5e1e05e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1e05e2",
  null
  
)

export default component.exports